import React from 'react';

import Page from "../../layouts/Main/Page";
import AccountCard from "./AccountCard";
import AlloggiatiAccountsCard from "./AlloggiatiAccountsCard";
import AbitAccountsCard from "./AbitAccountsCard";
import EmailProvidersCard from "./EmailProviders";
import QuoteSettingsCard from "./QuoteSettingsCard";
import AutoReplyCard from "./AutoReplyCard";

import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";


const Settings = () => {
    return (
        <Page title="Impostazioni">
            <Container maxWidth="md" disableGutters={true}>
                <Box sx={{mb: 2}}>
                    <Typography variant="h5" component="h2" sx={{py: 2}}>
                        Utente
                    </Typography>
                    <AccountCard/>
                </Box>

                <Box sx={{my: 2}}>
                    <Typography variant="h5" component="h2" sx={{py: 2}}>
                        Servizio invio email
                    </Typography>
                    <EmailProvidersCard/>
                </Box>

                <Box sx={{my: 2}}>
                    <Typography variant="h5" component="h2" sx={{py: 2}}>
                        Risposte automatiche
                    </Typography>
                    <AutoReplyCard/>
                </Box>

                <Box sx={{my: 2}}>
                    <Typography variant="h5" component="h2" sx={{py: 2}}>
                        Account alloggiati
                    </Typography>
                    <AlloggiatiAccountsCard/>
                </Box>

                <Box sx={{my: 2}}>
                    <Typography variant="h5" component="h2" sx={{py: 2}}>
                        Account Abit
                    </Typography>
                    <AbitAccountsCard/>
                </Box>

                <Box sx={{my: 2}}>
                    <Typography variant="h5" component="h2" sx={{py: 2}}>
                        Preventivi e prenotazioni
                    </Typography>
                    <QuoteSettingsCard/>
                </Box>
            </Container>
        </Page>
    );
};

export default Settings;